import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {getCompanyInfo, HttpGetCompanyInfoOptions} from '@/features/company-info/http/company-info.http'
import {CompanyInfo} from '@/features/company-info/types'

export const useGetCompanyInfo = (
    options?: HttpGetCompanyInfoOptions,
    queryOptions?: Omit<UseQueryOptions<CompanyInfo>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.COMPANY_INFO],
        queryFn: () => getCompanyInfo(options).then(response => response.data),
        ...queryOptions
    })
}
